rg<template>
    <div class="app-sidebar" :class="{collapsed}">

        <div class="logo-wrap">
            <img :src="theme_logo" class="logo" alt="">
            <button v-if="sidebar.collapsed"
                    class="btn btn-light d-flex align-items-center hamburger"
                    type="button"
                    @click="sidebar_collapse_toggle()">
                <img src="/images/icons/bars.svg" alt="">
            </button>

            <button v-if="!sidebar.collapsed"
                    class="btn btn-light d-flex align-items-center cross"
                    type="button"
                    @click="sidebar_collapse_toggle()">
                <img src="/images/icons/xmark-solid.svg" alt="">
            </button>

        </div>

        <div class="navigation-links">

<!--            <app-nav-link :active="active"-->
<!--                          :collapsed="collapsed"-->
<!--                          class="my-1" href="https://google.com/" icon="plus-circle-solid"-->
<!--                          icon-active="plus-circle-solid-light">-->
<!--                New Change Project-->
<!--            </app-nav-link>-->

<!--            <app-nav-link v-if="is_onboarding_teacher"-->
<!--                          :active="true"-->
<!--                          :collapsed="collapsed"-->
<!--                          class="my-1" :href="route('onboard.teacher')"-->
<!--                          icon="dashboard" icon-active="dashboard-light">-->
<!--                Welcome aboard-->
<!--            </app-nav-link>-->

            <div class="project-nav-group group-active">
<!--                <div class="group-head">-->
<!--                    <app-nav-link :active="false"-->
<!--                                  :collapsed="collapsed"-->
<!--                                  class="my-1"-->
<!--                                  :href="route('project.dashboard', {...global_url_params})"-->
<!--                                  icon="dashboard" icon-active="dashboard-light">-->
<!--                        Change Projects-->
<!--                    </app-nav-link>-->
<!--                </div>-->

                <div class="group-items">
<!--                    <app-nav-link :active="route().current('project.dashboard')"-->
<!--                                  :collapsed="collapsed"-->
<!--                                  class="my-1"-->
<!--                                  :href="route('project.dashboard')"-->
<!--                                  icon="dashboard" icon-active="dashboard-light">-->
<!--                        Dashboard-->
<!--                    </app-nav-link>-->


<!--                    <app-nav-link :active="route().current('podcast.*')"-->
<!--                                  :collapsed="collapsed"-->
<!--                                  class="my-1"-->
<!--                                  :href="route('podcast.index.backend', {...global_url_params})"-->
<!--                                  icon="podcast-dark"-->
<!--                                  icon-active="podcast-light">-->
<!--                        Podcasts-->
<!--                    </app-nav-link>-->


                    <p class="sub-title">Social Cause Podcasts</p>

                    <app-nav-link :active="route().current('modules.*')"
                                  :collapsed="collapsed"
                                  class="my-1" :href="route('modules.index', {...global_url_params})"
                                  icon="podcast-dark" icon-active="podcast-light">
                        Modules
                    </app-nav-link>

                    <template v-if="is_admin">
                        <app-nav-link :active="route().current('pc.*')"
                                  :collapsed="collapsed"
                                  class="my-1" :href="route('pc.index', {...global_url_params})"
                                  icon="podcast-dark" icon-active="podcast-light">
                            Podcasts
                        </app-nav-link>
                    </template>

                    <app-nav-link :active="route().current('canvas-element.*') && $page.props.type === 'activity'"
                                  :collapsed="collapsed"
                                  class="my-1" :href="route('canvas-element.index', {type: 'activity', ...global_url_params})"
                                  icon="activity" icon-active="activity-light">
                        Activities
                    </app-nav-link>

                    <template v-if="is_admin">
                        <app-nav-link :active="route().current('canvas-element.*') && $page.props.type === 'resource'"
                                      :collapsed="collapsed"
                                      class="my-1" :href="route('canvas-element.index', {type: 'resource', ...global_url_params})"
                                      icon="files" icon-active="files-light">
                            Resources
                        </app-nav-link>
                    </template>

                    <hr>

                    <p class="sub-title">Student Action Projects</p>

                    <app-nav-link :active="route().current('project.submit.*')"
                                  :collapsed="collapsed"
                                  class="my-1" :href="route('project.submit', {...global_url_params})"
                                  icon="trophy-primary" icon-active="trophy-light">
                        Submit Your Project!
                    </app-nav-link>

                    <app-nav-link :active="route().current('project.index')"
                                  :collapsed="collapsed"
                                  :href="route('project.index', {...global_url_params})"
                                  class="my-1"
                                  icon="flag-checker" icon-active="flag-checker-light">
                        Your Projects
                    </app-nav-link>

                    <app-nav-link :active="route().current('project.learning-path.*')"
                                  :collapsed="collapsed"
                                  class="my-1" :href="route('project.learning-path.index', {...global_url_params})"
                                  icon="files" icon-active="files-light">
                        Learning Paths
                    </app-nav-link>

                    <hr>

                    <p class="sub-title">Teacher Support</p>

                    <app-nav-link :active="route().current('page.pd')"
                                  :collapsed="collapsed"
                                  class="my-1" :href="route('page.pd', {...global_url_params})"
                                  icon="news" icon-active="news-light">
                        Professional Development
                    </app-nav-link>

                    <app-nav-link :active="route().current('page.help-center')"
                                  :collapsed="collapsed"
                                  class="my-1" :href="route('page.help-center', {...global_url_params})"
                                  icon="dashboard" icon-active="dashboard-light">
                        Help Center
                    </app-nav-link>

<!--                    <app-nav-link :active="active"-->
<!--                                  :collapsed="collapsed"-->
<!--                                  class="my-1" href="https://google.com/"-->
<!--                                  icon="archive" icon-active="archive-light">-->
<!--                        Archived-->
<!--                    </app-nav-link>-->

                </div>

            </div>

            <div class="project-nav-group group-active" v-if="is_admin">
                <div class="group-items">
                    <p class="sub-title">Super Administration</p>
                    <app-nav-link v-if="is_admin"
                                  :active="route().current('tenant.*')"
                                  :collapsed="collapsed"
                                  class="my-1"
                                  :href="route('tenant.index', {...global_url_params})"
                                  icon="users"
                                  icon-active="users-light">
                        Tenants
                    </app-nav-link>

                    <app-nav-link v-if="is_admin"
                                  :active="route().current('usr.*')"
                                  :collapsed="collapsed"
                                  class="my-1"
                                  :href="route('usr.index', {...global_url_params})"
                                  icon="users"
                                  icon-active="users-light">
                        Users
                    </app-nav-link>

                    <app-nav-link v-if="is_admin"
                                  :active="route().current('organization.*')"
                                  :collapsed="collapsed"
                                  class="my-1"
                                  :href="route('organization.index', {...global_url_params})"
                                  icon="users"
                                  icon-active="users-light">
                        Organizations
                    </app-nav-link>

                    <app-nav-link v-if="is_admin"
                                  :active="route().current('message-template.*')"
                                  :collapsed="collapsed"
                                  class="my-1"
                                  :href="route('message-template.index', {...global_url_params})"
                                  icon="files"
                                  icon-active="files-light">
                        Message Templates
                    </app-nav-link>
                </div>
            </div>


<!--            <app-nav-link :active="active"
                          :collapsed="collapsed"
                          class="my-1" href="https://google.com/"
                          icon="users" icon-active="users-light">
                Class &amp; Students
            </app-nav-link>


            <app-nav-link :active="active"
                          :collapsed="collapsed"
                          class="my-1" href="https://google.com/"
                          icon="news" icon-active="news-light">
                News
            </app-nav-link>-->

            <div class="project-nav-group group-active" v-if="is_admin">
                <div class="group-items">
                    <p class="sub-title">Reporting</p>
                    <app-nav-link :active="route().current('report.org')"
                                  :collapsed="collapsed"
                                  class="my-1" :href="route('report.org', {...global_url_params})"
                                  icon="news" icon-active="news-light">
                        Organizational Report
                    </app-nav-link>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import AppNavLink from "@/Components/AppNavLink";
import {mapMutations, mapState} from "vuex";

export default {
    name: "AppSidebar",
    components: {AppNavLink},
    props: ['collapsed'],

    data(){
        return {
            active: false,
        }
    },

    computed: {
        ...mapState(['sidebar']),

        is_onboarding_teacher(){
            // return this.route().current('onboard.teacher*');
            return false;
        },

        check_paid() {
            return true;
        },

        check_free() {
            return false;
        }

    },

    methods: {
        ...mapMutations(['sidebar_collapse_toggle']),
    }

}
</script>

<style lang="scss" scoped>
.app-sidebar{
    height: 100%;
    box-shadow: 0 0 3px #0000001A;
    border-right: rgba(150,150,150,0.1) solid 1px;
    display: flex;
    flex-direction: column;

    .logo-wrap{
        .hamburger{
            display: none !important;
        }

        .cross{
            display: none !important;
        }
    }
}

.navigation-links{
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    margin-top:  -2em;
    // justify-content: center;
    overflow-y: auto;

    .sub-title {
        font-size:  .9rem;
        font-weight:  bold;
        padding: .4rem .4rem .4rem 10px;
        margin-bottom:  .5rem;
        margin-top: -1rem;
        background: rgba(black, .1);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

@media (min-width: 650px) and (max-width: 1199px){
    .app-sidebar{
        .logo-wrap{
            position: relative;
            z-index: 9999 + 54;
            .hamburger{
                display: block !important;
                position: absolute;
                top: 50%;
                right: -35px;
                transform: translateY(-60%);

            }

            .cross{
                display: block !important;
                position: absolute;
                top: 50%;
                right: -15px;
                transform: translateY(-60%);
                padding: 6px 12px;

                img{
                    width: 16px;
                }

            }
        }
    }

    .navigation-links{

        .sub-title {
            font-size:  .5rem;
        }
    }
}

.logo{
    display: block;
    padding: 1rem 0.3rem;
    margin: 0 auto 1rem;
    max-width: 100%;
    height: auto;
}

.project-nav-group{
    //  padding: 0.6rem 0;
    margin: 1rem 0;
    background: rgba(darken(#EEF1F3, 10%), 0.35);
    border-top: 1px solid $light-borders;
    border-bottom: 1px solid $light-borders;

    .group-head{
        background: rgba(darken(#D8DEE4, 10%), 0.25);
    }

    &.group-active{
        .group-head{
            padding: 0.4rem 0;
        }

        .group-items{
            display: block;
        }
    }

    .group-items{
        display: none;
        padding: 1rem 0;
    }
}

</style>
